/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-multi-spaces */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-debugger */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { motion, AnimatePresence } from 'framer-motion';
import React, {
    useState, useRef, useEffect, useCallback,
} from 'react';
import Modal from 'react-modal';
import { Link } from 'react-router-dom';
import { CamelCase, TitleCase } from '../../redux/helper/CamelCase';
import { GenerateDate } from '../../redux/helper/DateConverter';
import { userService } from '../../service/user.service';
import ThreeDotsLoader from '../../Components/LoadingDots';
import ModalPopup from '../../Components/ModalHandler';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};
function ListUsers({
    setisPaneOpen,
    userList,
    render,
    currentPage,
    setCurrentPage,
    totalPage,
    setrender,
    setEditDAte,
    EditDAte,
    seteditpaneopen,
    handleSort,
    setsort,
    sort,
    setsortType,
    filter,
    handleActivateOrDeactivate,
    OpenPopup,
    setOpenPopup,
    actvloader,
    setactvloader,
    isEditId,
    setisEditId,
    setExportClick,
    isLoaded,
    updateuserprevilegeassigned,
    activateDeactivateprevilegeassigned,
    resetprevilegeassigned,
    manageUserList,
    setManageUserList,
    isUserList,
    setIsUserList,
}) {
    const [searchValue, setsearchValue] = useState('');
    const [loading, setloading] = useState(false);
    const [statusLoader, setstatusLoader] = useState('');
    const [selectedUser, setselectedUser] = useState([]);
    const ref = useRef();
    const SerachUser = (val) => {
        if (searchValue === '') {
            return val;
        }
        if (val.email.toLowerCase().includes(searchValue.toLowerCase())) {
            return val;
        }
    };
    return (
        <AnimatePresence>
            <tbody>
                <Modal
                    style={customStyles}
                    isOpen={OpenPopup !== ''}
                    ariaHideApp={false}
                    onClick={() => {
                        setOpenPopup('');
                        setactvloader(false);
                    }}
                    onRequestClose={() => setOpenPopup('')}

                >
                    <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none max-w-[441px]">
                        <div
                            className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current"
                        >
                            <div className="modal-header flex flex-shrink-0 items-center justify-between p-4 pt-7 rounded-t-md">
                                {OpenPopup === 'active' ? (
                                    <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel">
                                        {selectedUser.admin_status === '0' ? 'Activate' : 'Deactivate'}
                                        {' '}
                                        {' '}
                                        User
                                    </h5>
                                ) : (
                                    <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel">
                                        Reset Password
                                    </h5>
                                )}
                                <button
                                    type="button"
                                    className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute top-4 right-6"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            {OpenPopup === 'active' ? (
                                <div className="modal-body relative px-9 pt-2 pb-6 text-center">
                                    {manageUserList.length > 0 && isUserList
                                        ? (
                                            <div>
                                                <h5 className="text-[#555259] font-normal text-[15px]">{`${selectedUser.first_name} ${selectedUser.last_name} is currently the reporting manager for the following  employees:`}</h5>
                                                <ul className="text-center overflow-auto h-[110px] w-[95%] px-[5%] mx-auto User-list mt-1">
                                                    <div className="h-max w-max">
                                                        {manageUserList.map((item, index) => (
                                                            <div key={index} className="flex items-center justify-start mb-1 w-full">
                                                                <p className="text-[#555259] font-normal text-[15px] w-[130px] text-start">{item.employee_code}</p>
                                                                <p className="text-[#555259] font-normal text-[15px]"> - </p>
                                                                <div className="flex items-center ml-2 w-[70%] justify-start pr-1">
                                                                    <p className="text-[#555259] font-normal text-[15px] mr-1 text-nowrap">
                                                                        {item.first_name}
                                                                        {' '}
                                                                        {item.last_name}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </ul>
                                            </div>
                                        )
                                        : (
                                            <p className="text-xs6 font-normal text-[#555259]">
                                                {`${selectedUser.first_name} ${selectedUser.last_name}`}
                                                {' '}
                                                is currently
                                                {' '}
                                                {selectedUser.admin_status === '1' ? 'Active' : 'Inactive'}
                                                . Are you sure you
                                                {' '}
                                                want to
                                                {' '}
                                                {selectedUser.admin_status === '1' ? 'Deactivate' : 'Activate'}
                                                ?
                                            </p>
                                        )}
                                </div>
                            ) : (
                                <div className="modal-body relative px-9 pt-2 pb-6 text-center">
                                    <p className="text-xs6 font-normal text-[#555259]">
                                        Are you sure you want to reset the password for
                                        <br />
                                        {`${selectedUser.first_name} ${selectedUser.last_name}`}
                                        ?
                                    </p>
                                </div>
                            )}
                            {manageUserList.length > 0 && isUserList
                                ? (
                                    <div className="w-full flex justify-center pb-6">
                                        <button
                                            onClick={() => {
                                                setOpenPopup('');
                                                setactvloader(false);
                                                setIsUserList(false);
                                            }}
                                            type="button"
                                            className="border border-[#673593] bg-[#555259]  w-[158px] flex justify-center text-base font-normal text-[#FFFFFF] py-3 px-14 rounded-lg"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                        >
                                            Back
                                        </button>
                                    </div>
                                )
                                : (
                                    <div className="modal-footer flex flex-shrink-0 flex-wrap justify-evenly pb-6 rounded-b-md">
                                        <button
                                            onClick={() => {
                                                setOpenPopup('');
                                                setactvloader(false);
                                            }}
                                            type="button"
                                            className="border border-[#555259] bg-[#ffffff] text-base font-normal text-[#555259] py-3 px-14 rounded-lg"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="button"
                                            className="border border-[#673593] bg-[#555259] text-base font-normal text-[#ffffff] py-3 px-14 rounded-lg"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                            disabled={actvloader}
                                            onClick={() => handleActivateOrDeactivate(selectedUser.admin_status === '1' ? '0' : '1', selectedUser.email)}
                                        >
                                            {actvloader ? <ThreeDotsLoader /> : 'Yes'}
                                        </button>
                                    </div>
                                )}
                        </div>
                    </div>
                </Modal>
                {Object.keys(userList).length > 0 && userList.users?.Items.filter((val) => SerachUser(val)).map((user, i) => (
                    <>
                        <motion.tr
                            className="bg-[#FDFDFE] border-b border-[#DFEAF7] relative"
                            key={`${user.employee_code}-${i}`}
                            style={{ zIndex: `${50 - i}` }}
                            animate={{ opacity: 1, x: 0 }}
                            initial={{ opacity: 0, x: -10 }}
                            exit={{ opacity: 0, x: -10 }}
                            transition={{ duration: 0.15 }}
                        >
                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 sticky left-0 bg-[#FDFDFE]">
                                {user.employee_code}
                            </td>
                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7">
                                {user.first_name}
                            </td>
                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7">
                                {user.last_name}
                            </td>
                            <td className="text-sm font-normal text-[#090406]">
                                {CamelCase(user.roles?.replace(/_/g, ' '))}
                            </td>
                            <td title={user?.territory_list} className="text-sm font-normal text-[#090406] whitespace-nowrap min-w-[200px] max-w-[400px] text-ellipsis overflow-hidden py-2.5 px-7">
                                {user?.territory_list !== '' ? user?.territory_list : '-'}
                            </td>
                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7">
                                {`${user.reporting_manager_first_name} ${user?.reporting_manager_last_name} (${user?.reporting_manager_employee_code || '-'})`}
                            </td>
                            <td className="text-xs font-normal py-2.5 px-7 text-center">
                                <a
                                    href="#"
                                    className={`cursor-default flex rounded-sm border-2 ${user.admin_status === '1' ? 'border-[#D7F8DC] bg-[#D7F8DC]' : 'border-[#808285] bg-[#808285] text-[#FFFFFF]'} py-0.5 pr-1.5 w-fit`}
                                >
                                    <img src={`images/${user.admin_status === '1' ? 'Active-icon.svg' : 'inactive-1.svg'}`} alt="icon" className="px-2" />
                                    {user.admin_status === '1' ? 'Active' : 'Inactive'}
                                </a>
                            </td>
                            {/* <td className="text-sm font-normal text-[#090406] py-2.5 px-7">
                                {user.third_party_logistics[0]}
                            </td>
                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7">
                                {user.territory}
                            </td> */}
                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7">
                                {user.phone_number}
                            </td>
                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7">
                                {user.email}
                            </td>
                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7">
                                {GenerateDate(user.activated_datetime)}
                            </td>
                            <td className="text-sm font-normal text-[#090406]  text-center">
                                {user.deactivated_datetime ? GenerateDate(user.deactivated_datetime) : '-'}
                            </td>
                            <td className={`py-2.5 px-7 sticky right-0 bg-[#FDFDFE] ${filter || OpenPopup ? '' : 'z-50'} `}>
                                <div
                                    className="dropdown relative flex justify-center cursor-pointer"
                                    onClick={() => {
                                        if (isEditId === i) {
                                            setisEditId('');
                                        } else {
                                            setisEditId(i);
                                        }
                                    }}
                                >
                                    <button className="dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                        <img
                                            src="images/more-vertical.svg"
                                            alt="icon"
                                        />
                                    </button>
                                    {isEditId !== '' && (

                                        <ul
                                            className={`dropdown-menu min-w-max absolute ${isEditId === i ? 'show' : 'hidden'} bg-[#FFFFFF] rounded-[10px] shadow-s2 z-[${i + 50}]`}
                                            aria-labelledby="dropdownMenuButton1"
                                            style={{ right: '60px' }}
                                        >
                                            {' '}
                                            {resetprevilegeassigned
                                                && (
                                                    <li
                                                        className="px-5 pb-1.5 pt-5"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#resetpasswordModal"
                                                        onClick={() => {
                                                            setselectedUser(user);
                                                            setOpenPopup('reset');
                                                            setisEditId('');
                                                        }}
                                                        ref={ref}
                                                    >
                                                        <a className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block" href="javascript:void(0)">Reset Password</a>
                                                    </li>
                                                )}
                                            {updateuserprevilegeassigned
                                                && (
                                                    <li className="px-5 py-1.5" ref={ref}>
                                                        <Link to={`/manage-internal-users/${user.email}/edit`} className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block" href="edit-admin-user.html">Edit</Link>
                                                    </li>
                                                )}
                                            {activateDeactivateprevilegeassigned
                                                && (
                                                    <li
                                                        className="px-5 pt-1.5 pb-5"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#deactivateUserModal"
                                                        onClick={() => {
                                                            setselectedUser(user);
                                                            setOpenPopup('active');
                                                            setisEditId('');
                                                        }}
                                                        ref={ref}
                                                    >
                                                        <a
                                                            className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block"
                                                            href="javascript:void(0)"
                                                        >
                                                            {user.admin_status === '1' ? 'Deactivate' : 'Activate'}

                                                        </a>
                                                    </li>
                                                )}
                                        </ul>
                                    )}
                                </div>
                            </td>
                        </motion.tr>
                        <tr className="h-1" />

                    </>
                ))}
            </tbody>
        </AnimatePresence>
    );
}

export default ListUsers;
